<template>
	<div class="subject-audit-detail">
		<div class="container-fluid">
			<!-- Begin page -->
			<div class="wrapper">
				<div class="content-page content-subProject">
					<div class="content">
						<div class="row">
							<div class="col-12">
								<div class="page-title-box">
									<div class="page-title-right"><Breadcrumb /></div>
									<h3 class="header-title mb-3">作品详情</h3>
								</div>
								<!-- end page-title-box -->
							</div>
						</div>

						<div class="row">
							<div class="col-12">
								<div class="card">
									<div class="card-body">
										<div class="card-reviewDetails">
											<h3 class="text-center">{{ topicInfo.title }}</h3>
											<div class="row row-reviewDetails">
												<div class="col-6 col-md-3">申报人：{{ topicInfo.userName }}</div>
												<div class="col-6 col-md-3">所属单位：{{ topicInfo.unit }}</div>
												<div class="col-6 col-md-3">主要参与者：{{ topicInfo.record }}</div>
												<div class="col-6 col-md-3">联系电话：{{ topicInfo.phone }}</div>
												<div class="col-6 col-md-3">学段：{{ topicInfo.learningSectionString }}</div>
												<div class="col-6 col-md-3">学科：{{ topicInfo.disciplineIdString }}</div>
												<div class="col-6 col-md-3">上传时间：{{ topicInfo.createTime }}</div>
												<div class="col-12">简介：{{ topicInfo.introduction }}</div>
											</div>
											<!-- 在线开题报告 -->
											<div class="view">
												<h4>报告名称：{{ topicInfo.reportName }}</h4>
												<iframe ref="myIframe" height="100%" width="100%"></iframe>
											</div>
											<div style="margin-top: 8vh;" v-for="(item, index) in list2" :key="item.id">
												<div class="col-form-label">{{ item.auditType == 3 ? '区级审核' + (index + 1) : '学校审核' + (index + 1) }}</div>
												<!-- <label class="col-md-2 col-12 col-form-label" style="text-align: right;">{{item.auditType==1?'区级审核'+(index+1):'学校审核'+(index+1)}}</label> -->
												<!-- <div class="col-md-9 col-10"> -->
												<table class="table table-bordered table-centered mb-0">
													<tbody>
														<tr>
															<th style="width: 90px;">审核意见</th>
															<td>{{ item.auditState ? '通过' : '不通过' }}</td>
															<th>审核人</th>
															<td>{{ item.auditName }}</td>
															<th>审核时间</th>
															<td>{{ item.createTime | getTime }}</td>
														</tr>
														<tr>
															<th style="width: 90px;">审核说明</th>
															<td colspan="5">{{ item.auditExplain }}</td>
														</tr>
													</tbody>
												</table>
												<!-- </div> -->
												<div class="col-md-1 col-2"><span class="required"></span></div>
											</div>
											<div class="text-center"><button type="button" class="btn btn-light" style="margin-left: 20px;" @click="goBack">返回</button></div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<!-- end wrapper-->
		</div>
	</div>
</template>

<script>
import { getApiReviewInfo } from '@/api/after/newInterface.js';
import { topicDetailByIdAndReviewType, topicManageReview } from '@/api/after/topicManage.js';
import Breadcrumb from '@/views/backstage/components/Breadcrumb.vue';
export default {
	components: {
		Breadcrumb
	},
	data() {
		return {
			list2: [{ auditState: '1' }],
			filePreviewDialogVisible: false,
			curPreviewFileDialogTitle: '',
			curPreviewFileType: '', //当前预览文件类型
			curPreviewFileUrl: '', //当前预览文件URL
			auditForm: {
				projectManagementId: '', //课题管理id
				auditType: 1, //审核类型（0：校审,1:学段审）
				type: 1, //审查类型(0:开题,1:中期,2:结题申请,3:结题)
				auditState: '', //审核意见
				auditExplain: '' //审核说明
			},
			auditFormRules: {
				auditState: [{ required: true, message: '请选择审核意见', trigger: 'change' }],
				auditExplain: [{ required: true, message: '请输入审核说明', trigger: 'blur' }]
			},
			topicInfo: {}, //课题信息
			curFileTitleIndex: 0,
			fileTitleList: ['开题报告', '相关资料'],
			// isOverTime:false,//当前项目是否超过审核时间
			declarationContents: null, //申报书内容附件
			anonymousReview: null //匿名评审活页
		};
	},
	filters: {
		getMember(val) {
			if (val) {
				return val.replace(/,/g, '、');
			}
		},
		formatFileType(val) {
			switch (val) {
				case 'pic':
					return '图片';
					break;
				case 'doc':
					return '文档';
					break;
				case 'docx':
					return '文档';
					break;
				case 'video':
					return '视频';
					break;
				case 'other':
					return '其他文件';
					break;
				default:
			}
		}
	},
	computed: {
		// 展示所有负责人
		getAllEmcee() {
			if (Object.keys(this.topicInfo).length) {
				if (this.topicInfo.twoEmceeName) {
					return `${this.topicInfo.oneEmceeName}、${this.topicInfo.twoEmceeName}`;
				} else {
					return this.topicInfo.oneEmceeName;
				}
			}
		}
	},
	async mounted() {
		let id = this.$route.query.id;
		if (id) {
			let params = {
				id,
				type: 0
			};
			// await this.getTopicDetailByIdAndReviewType(params);
			this.auditForm.projectManagementId = this.topicInfo.projectManagementId;
			// // 数据请求成功之后渲染pdf
			if (Object.keys(this.topicInfo).length) {
				this.$refs.myIframe.contentWindow.location.replace(`${this.uploadUrl}/upload/downloadPdf/${this.topicInfo.annex}`);
			}
		}
		this.getInfo();
	},
	methods: {
		//附件分页详情
		getInfo() {
			getApiReviewInfo(this.$route.query.id).then(res => {
				this.topicInfo = res.data;
			});
		},
		// 关闭文件预览对话框
		closePreviewFileDialog() {
			this.filePreviewDialogVisible = false;
			if (this.curPreviewFileType === 'video') {
				console.log('预览视频ref', this.$refs.previewVideo);
				this.$refs.previewVideo.pause();
			}
		},
		// 打开预览文件对话框
		preview(item) {
			if (item.fileType == 'doc' || item.fileType == 'docx') {
				window.open(`${this.uploadUrl}/upload/downloadPdf/${item.id}`, '_blank');
			} else if (item.fileType == 'video') {
				this.curPreviewFileDialogTitle = '视频预览';
				this.curPreviewFileType = 'video';
				this.curPreviewFileUrl = `${this.uploadUrl}/upload/previewVideo/${item.id}`;
				this.filePreviewDialogVisible = true;
			} else if (item.fileType == 'pic') {
				window.open(`${this.uploadUrl}/upload/previewImage/${item.id}`, '_blank');
			} else {
				window.open(`${this.uploadUrl}/upload/download?id=${item.id}&openStyle=1`, '_blank');
			}
		},
		// 课题申报详情
		async getTopicDetailByIdAndReviewType(params) {
			const res = await topicDetailByIdAndReviewType(params);
			if (res.code == 200) {
				this.topicInfo = res.data;
			} else {
				this.$message.error(res.data);
			}
		},
		// 提交审核
		async topicManageReview() {
			const res = await topicManageReview(this.auditForm);
			if (res.code == 200) {
				this.$message.success('提交审核成功！');
				this.goBack();
			} else {
				this.$message.error(res.data);
			}
		},
		// 提交审核结果
		submitAudit() {
			this.topicManageReview();
		},
		goBack() {
			if (this.$route.query.pageNumber && this.$route.query.auditType) {
				sessionStorage.setItem('pageNumber', this.$route.query.pageNumber);
				sessionStorage.setItem('auditType', this.$route.query.auditType);
			}
			this.$router.go(-1);
		},
		// 改变文件标题索引
		changeFileTitle(index) {
			if (index == 0) {
				this.curFileTitleIndex = index;
				this.$refs.myIframe.contentWindow.location.replace(`${this.uploadUrl}/upload/downloadPdf/${this.topicInfo.annex}`);
			} else {
				if (this.topicInfo.annexList && this.topicInfo.annexList.length == 1) {
					let fileObj = this.topicInfo.annexList[0];
					if (fileObj.fileType == 'doc' || fileObj.fileType == 'docx') {
						this.curFileTitleIndex = index;
						this.$refs.myIframe1.contentWindow.location.replace(`${this.uploadUrl}/upload/downloadPdf/${fileObj.id}`);
					} else if (fileObj.fileType == 'video') {
						this.curPreviewFileDialogTitle = '视频预览';
						this.curPreviewFileType = 'video';
						this.curPreviewFileUrl = `${this.uploadUrl}/upload/previewVideo/${fileObj.id}`;
						this.filePreviewDialogVisible = true;
					} else if (fileObj.fileType == 'pic') {
						window.open(`${this.uploadUrl}/upload/previewImage/${fileObj.id}`, '_blank');
					} else {
						window.open(`${this.uploadUrl}/upload/download?id=${fileObj.id}&openStyle=1`, '_blank');
					}
				} else {
					this.curFileTitleIndex = index;
				}
			}
		},
		handleClose(done) {
			this.$confirm('确认关闭？')
				.then(_ => {
					done();
				})
				.catch(_ => {});
		}
	}
};
</script>

<style scoped lang="scss">
.view_report {
	margin-top: 50px;
}
.preview_wrap {
	height: 100%;
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
}
.file_list {
	border-bottom: 1px solid #ccc;
	.file_list_title {
		font-size: 18px;
		font-weight: bolder;
		margin-bottom: 15px;
	}
	.file_item {
		display: flex;
		align-items: center;
		margin-bottom: 10px;
		cursor: pointer;
		.file_type {
			font-size: 18px;
			font-weight: bolder;
			margin-right: 20px;
		}
	}
	.file_item:hover {
		color: #006dcc;
	}
}
.view {
	width: 1000px;
	height: 500px;
}
.comments-list {
	margin-top: 20px;
}
.file-list {
	width: 100%;
	display: flex;
	justify-content: center;
	padding-left: 0;
	list-style: none;
	.file-item {
		font-size: 24px;
		text-align: center;
		width: 50%;
		border-bottom: 2px solid #eee;
		cursor: pointer;
	}
}
.file-item.active {
	border-color: #00a2e8;
}
</style>
